import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UserData } from './avatar.types';

@Component({
  selector: 'cohrex-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AvatarComponent {
  private _userData?: UserData = {
    name: 'Cohr Group'
  };
  @Input()
  set userData(value: UserData | undefined) {
    this._userData = value;
  }
  get userData(): UserData | undefined {
    return this._userData;
  }

  private _showName?: boolean = false;
  @Input()
  set showName(value: boolean | undefined) {
    this._showName = value;
  }
  get showName(): boolean | undefined {
    return this._showName;
  }
}
